import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import { PageQuestions, TimeLeft, MIN_NUMBER_OF_QUESTIONS, MAX_NUMBER_OF_QUESTIONS } from "./consts";
export var getDuration = function getDuration(completedQuestions) {
  var questionPages = PageQuestions;
  var currentPage = 1;
  questionPages.forEach(function (questions, page) {
    if (questions.some(function (q) {
      return completedQuestions.includes(q);
    })) {
      currentPage = page;
    }
  });
  var timeLeft = TimeLeft[currentPage];
  var numQuestionsCompleted = completedQuestions.length;
  var questionsLeft;
  if (numQuestionsCompleted === 7) questionsLeft = '0-1';else if (numQuestionsCompleted === 8) questionsLeft = 0;else {
    questionsLeft = "".concat(MIN_NUMBER_OF_QUESTIONS - numQuestionsCompleted, "-").concat(MAX_NUMBER_OF_QUESTIONS - numQuestionsCompleted);
  }
  return [timeLeft, "".concat(questionsLeft, " questions")];
};